import React, { useState } from 'react'
import CalculationConfigList from './CalculationConfigList'
import CalculationConfigEditor from './CalculationConfigEditor'

/**
 * Calculation Configuration Manager
 * Parent component that manages navigation between list and editor views
 */
const CalculationConfigManager = () => {
  const [view, setView] = useState('list') // 'list' or 'edit'
  const [editingConfigId, setEditingConfigId] = useState(null)

  const handleEdit = (configId) => {
    setEditingConfigId(configId)
    setView('edit')
  }

  const handleSave = () => {
    setView('list')
    setEditingConfigId(null)
  }

  const handleClose = () => {
    setView('list')
    setEditingConfigId(null)
  }

  if (view === 'edit') {
    return (
      <CalculationConfigEditor
        configId={editingConfigId}
        onSave={handleSave}
        onClose={handleClose}
      />
    )
  }

  return (
    <CalculationConfigList
      onEdit={handleEdit}
    />
  )
}

export default CalculationConfigManager
